/* Mell — брояч до края на промоция. Ползва се и в анонса, и на страница Промоции.
   Употреба: <mell-countdown data-ends="2026-10-10T23:59:59+03:00"></mell-countdown> */
(function(){
  if (window.customElements && customElements.get('mell-countdown')) return;
  var L = ['дни','часа','мин.','сек.'];
  class MellCountdown extends HTMLElement {
    connectedCallback(){
      this.end = Date.parse(this.dataset.ends || '');
      if (isNaN(this.end)) { this.remove(); return; }
      this.build();
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }
    disconnectedCallback(){ clearInterval(this.timer); }
    build(){
      this.innerHTML = L.map(function(l){
        return '<span class="mp-cd__u"><b class="mp-cd__n">--</b><i class="mp-cd__l">'+l+'</i></span>';
      }).join('');
      this.nums = this.querySelectorAll('.mp-cd__n');
    }
    tick(){
      var s = Math.floor((this.end - Date.now())/1000);
      if (s <= 0){ clearInterval(this.timer); s = 0; this.setAttribute('data-over',''); }
      var v = [Math.floor(s/86400), Math.floor(s/3600)%24, Math.floor(s/60)%60, s%60];
      for (var i=0;i<4;i++) this.nums[i].textContent = (i && v[i]<10 ? '0' : '') + v[i];
    }
  }
  customElements.define('mell-countdown', MellCountdown);
})();
